import { IcCallIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import styles from './UserProfileJoinCallButton.m.css';

export const UserProfileJoinCallButton = ({ onClick }) => {
  return (
    <IconButton
      theme="10"
      Icon={IcCallIcon}
      onClick={onClick}
      className={styles.activeCallButton}
    />
  );
};
